<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">促销活动管理</div>
          <span class="m-title-s">促销活动编辑等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>信息列表
          </div>
          <div class="m-table-btn">
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border>
          <el-table-column prop="title" label="标题" width=""></el-table-column>
          <el-table-column prop="vipStatus" label="开启状态" width="110" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === '0'" type="success">开启</el-tag>
              <el-tag v-if="scope.row.status === '1'" type="danger">关闭</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="limitDate" label="到期时间" align="center">
            <template slot-scope="scope">
              <el-tag type="danger">{{ scope.row.limitDate }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createDate" label="创建时间" align="center"></el-table-column>
          <el-table-column prop="updateDate" label="修改时间" align="center"></el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openForm(scope.row)" plain>编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="750px" center :close-on-click-modal="false">
      <div class="m-open-container" v-loading="formLoading">
        <div class="zs-open-body-ov">
          <el-form :model="form" :rules="rules" ref="form" label-width="125px">
            <el-form-item label="vip标题: " prop="title">
              <el-input v-model="form.title" placeholder="输入诊断标题"></el-input>
            </el-form-item>
            <el-form-item label="活动提示: " prop="promotionTips">
              <el-input v-model="form.promotionTips" placeholder="逗号分隔，前端分解显示"></el-input>
            </el-form-item>
            <el-form-item label="倒计时名称: " prop="timeTips">
              <el-input v-model="form.timeTips" placeholder="输入倒计时名称"></el-input>
            </el-form-item>
<!--            <el-form-item label="活动比率: " prop="promotionRatio">-->
<!--              <el-input v-model="form.promotionRatio" placeholder="输入活动比率"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="到期时间: " prop="limitDate">
<!--              <el-input v-model="form.limitDate" placeholder="输入到期时间"></el-input>-->
              <el-date-picker
                v-model="form.limitDate"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="备注: " prop="remarks">
              <el-input v-model="form.remarks" placeholder="输入备注"></el-input>
            </el-form-item>
            <el-form-item label="开启状态: " prop="isStatus">
              <el-switch v-model="isStatus" active-text="开启" inactive-text="关闭"></el-switch>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="openState = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'promotion',
  data () {
    return {
      openText: '',
      openState: false,
      formLoading: false,
      isLoading: false,
      isStatus: false,
      list: [],
      form: {
        id: '',
        title: '',
        promotionTips: '',
        timeTips: '',
        promotionRatio: '',
        status: '',
        limitDate: '',
        remarks: ''
      },
      rules: {
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    audioDuration (e) {
      this.form.duration = e.duration
    },
    closeDialog: function () {
      this.form = {
        id: '',
        title: '',
        promotionTips: '',
        timeTips: '',
        promotionRatio: '',
        status: '',
        limitDate: '',
        remarks: ''
      }
      this.isStatus = false
    },
    openPopup () {
      this.openState = true
    },
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.form.status = this.isStatus ? '0' : '1'
          _this.formLoading = true
          this.$axios.post('/promotion/save', _this.form)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.loadData()
                _this.openState = false
                _this.formLoading = false
              } else {
                _this.$message.error(res.msg)
              }
            })
        } else {
          return false
        }
      })
    },
    openForm (row) {
      this.openText = '编辑'
      this.form = {
        id: row.id,
        title: row.title,
        promotionTips: row.promotionTips,
        timeTips: row.timeTips,
        promotionRatio: row.promotionRatio,
        status: row.status,
        limitDate: row.limitDate,
        remarks: row.remarks
      }
      this.isStatus = row.status === '0'
      this.openState = true
    },
    // 管理员列表
    loadData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/promotion/list')
        .then((res) => {
          _this.list = res.data
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/promotion/Promotion.vue